import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import type { ConversationAutomationChatbotLogEntry } from 'lib-shared-types-api';
import { useCallback } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';

type Props = {
  readonly node: ConversationAutomationChatbotLogEntry;
};

const exitReasonLabel: Record<string, string> = {
  HANDOFF_VIA_QUEUE: 'Handoff via queue',
  HANDOFF_VIA_BREAKING_CONTAINMENT: 'Handoff via continue with flow',
  HANDOFF_FAILED: 'Handoff',
  PROMPT_INJECTION: 'Prompt injection',
  BLOCKED_BY_CONTENT_POLICY: 'Blocked by content policy',
  UNABLE_TO_HANDLE: 'Unable to handle',
  UNSUPPORTED_MESSAGE: 'Unsupported message',
  UNKNOWN: 'Unknown',
};

export function RoutedThroughAiAgent({ node }: Props): JSX.Element {
  const navigate = useAppNavigate();
  const hasAiAgentReadAccess = useHasAccess([
    'settings.integration.channel.edit',
    'settings.chatbot',
  ]);

  const handleGoToAiAgent = useCallback(() => {
    if (!node.chatbot_id) return;
    navigate({
      path: '/settings/ai-agents/mim/:id',
      params: {
        path: {
          id: node.chatbot_id,
        },
      },
    });
  }, [navigate, node.chatbot_id]);

  return (
    <FlexBox alignItems="center" gap="200">
      <Text.Paragraph>
        AI agent
        {node.chatbot_name && (
          <>
            : <strong>{node.chatbot_name}</strong>
          </>
        )}{' '}
        {node.exit_reason && exitReasonLabel[node.exit_reason] && (
          <>
            · <strong>{exitReasonLabel[node.exit_reason]}</strong>
          </>
        )}
      </Text.Paragraph>
      {hasAiAgentReadAccess && node.chatbot_id && (
        <Button variant="secondary" onClick={handleGoToAiAgent}>
          Go to AI agent
        </Button>
      )}
    </FlexBox>
  );
}
